import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@osc-utils/services/configuration.service';

@Injectable()
export class IpmInterceptor implements HttpInterceptor {
  #configurationService = inject(ConfigurationService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.handle(request, next);
  }

  private handle(request: HttpRequest<any>, next: HttpHandler) {
    if (this.#configurationService.isWebApp()) {
      return next.handle(request);
    }

    // This is required to tell the http request to inject existing credentials, aka cookies
    // The ID token should not be passed into the Authorization header as long as we use cookies to authenticate
    //
    // This interceptor is run before ALL HTTP request, so configuring global parameters is perfect here
    // It is only using cookies as credentials when receiving a request from the same host
    //
    // In the future where this would be changed, we will need to replace this to inject the new headers using
    // the setHeaders property in the clone function.
    const crendentialedRequest = this.injectCredentials(request);
    return next.handle(crendentialedRequest);
  }

  private removePrefixes(hostname: string, prefixes: string[]) {
    let result = hostname;

    prefixes.forEach(prefix => {
      if (result.startsWith(prefix)) {
        result = result.substring(prefix.length);
      }
    });

    return result;
  }

  private injectCredentials(request: HttpRequest<any>): HttpRequest<any> {
    if (request.url.startsWith('http') || request.url.startsWith('ionic')) {
      const webHostnamePrefix = ['ipmapp.', 'ipm.'];
      const androidHostnamePrefix = ['ipmapp-android.'];

      let appHostname = window.location.hostname;
      appHostname = this.removePrefixes(appHostname, webHostnamePrefix);
      appHostname = this.removePrefixes(appHostname, androidHostnamePrefix);

      const url = new URL(request.url);
      let requestHostname = url.hostname;
      requestHostname = this.removePrefixes(requestHostname, webHostnamePrefix);
      requestHostname = this.removePrefixes(requestHostname, androidHostnamePrefix);

      if (requestHostname === appHostname) {
        return request.clone({ withCredentials: true });
      }
    }
    return request.clone();
  }
}
